<script>
import api from "@/axios";
import Loader from "../components/loader.vue";
import Layout from '../../layouts/main.vue'
import PageHeader from '@/components/page-header.vue'
import TransferenciasTable from './movajustes-table.vue'
import appConfig from "@/app.config.json";
import { Vue3Lottie } from 'vue3-lottie'
import 'vue3-lottie/dist/style.css'
import animationJson from '@/assets/animations/transf_anim.json'
import { pedidosChart1, pedidosChart2 } from "../components/data-simulados"
import exportFromJSON from "export-from-json"
import DropZone from "@/components/widgets/dropZone.vue";
import {ref} from "vue";
import useVuelidate from "@vuelidate/core";
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Movimentos de Ajuste de Estoque",
    meta: [{ name: "description", content: appConfig.description }]
  },

  components: {DropZone, Layout, PageHeader, TransferenciasTable, Loader, Vue3Lottie },
  mounted() {
    console.log('mounted movajuste-list_0')
    this.atualizaDataList()
  },

  setup() {
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0]
    };
    return { dropzoneFile, drop, v$: useVuelidate()};
  },
  data() {
    return {
      animationJson,
      title: 'Movimentos de Ajuste de Estoque',
      items: [
        {
          text: 'Estoque',
          href: '/',
        },
        {
          text: 'Movimentos de Ajuste de Estoque',
          active: true,
        },
      ],
      loadingList: true,
      loadingGraph: true,
      movajtList: null,
      pesqTextFilter: '',
      statusFilter: 'T',

      pedChart1: pedidosChart1,
      pedChart2: pedidosChart2,
      showModalImportarMovAjt: false,
      submittedAnexo: false,
      showPendenteModalImport: false
    }
  },
  methods: {
    baixarModeloImportacao(){
      api.get(`${getBaseUrl()}api/baixamodelomovajt`, {
        responseType: 'blob'
      }).then(response => {
        console.log('response.data')
        console.log(response.data)

        //Criando link temporário para realizar download
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'econopro_modelo_tabela_importa_ajuste_v1.xlsx'
        link.click()

        //limpando URL do objeto - limpando memória
        window.URL.revokeObjectURL(link)
      }).catch((error) => {
        console.log('erro ao baixar arquivo')
        console.log(error)
      })
    },

    selectedFile(){
      this.dropzoneFile = document.querySelector(".dropzoneFile").files[0]

      let arquivoEmMegas = (this.dropzoneFile.size / 1000000)
      if(arquivoEmMegas > 2){
        Swal.fire({
          position: 'center',
          icon: 'warning',
          title: 'Panilha não pode passar 2 megas!',
          showConfirmButton: false,
          timer: 4000
        }).then(() => {
          this.showModalImportarMovAjt = false
        })
      }
    },

    atualizaPagina(){
      window.locale.reload()
    },

    confirmarImportacaoMovAjt(){
      this.submittedAnexo = true
      if (this.dropzoneFile.name){
        this.showModalAtuLogo = false
        this.updating = true

        let arquivo = document.querySelector(".dropzoneFile").files[0]
        console.log(arquivo)

        let arquivoEmMegas = (arquivo.size / 1000000)

        if(arquivoEmMegas > 1) {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Panilha não pode passar 1 mega!',
            showConfirmButton: false,
            timer: 4000
          }).then(() => {
            this.showModalImportarMovAjt = false
            this.dropzoneFile = ""
          })
        }else{
          let formData = new FormData()
          formData.append("iddata", this.idData)
          formData.append("tipoUpload", this.tipoUpload)
          formData.append("filename", arquivo.name)
          formData.append("file", arquivo)

          this.showModalImportarMovAjt = false
          this.showPendenteModalImport = true

          api.post(`${getBaseUrl()}api/importmovajt`,formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then((res) => {
            console.log('then axios importmovajt')
            console.log(res.data)

            if(res.data.success){
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Planilha processada com sucesso!",
                showConfirmButton: false,
                timer: 2000
              }).then(() => {
                this.downloadErrorLog(res.data.erros)

                this.showPendenteModalImport = false
                this.$router.push(`/movajuste/editar/${res.data.movajt_id}`)
              })
            }else{
              let retorno = res.data

              if(retorno.message){
                Swal.fire({
                  position: "center",
                  icon: "error",
                  title: "Processamento falhou!",
                  text: res.data.message,
                  showConfirmButton: false,
                  timer: 5000
                }).then(() => {
                  this.dropzoneFile = ""
                  this.showPendenteModalImport = false
                })
              }else{
                this.downloadErrorLog(res.data.erros)
                console.log('montando texto erros')

                Swal.fire({
                  position: "top-end",
                  icon: "error",
                  title: "Processamento falhou!",
                  showConfirmButton: false,
                  timer: 1500
                }).then(() => {
                  this.showPendenteModalImport = false
                  this.dropzoneFile = ""
                })
              }
            }
          }).catch((err) => {
            console.log('erro axios')
            // console.log(err)
            // console.log(err.response)
            // console.log(err.response.data.errors)
            let erros = err.response.data.errors
            console.log(erros)
            console.log(typeof  erros)
            let listaErros = []
            Object.keys(erros).forEach(key => {
              console.log(key, erros[key]);
              listaErros.push({
                'titulo': key,
                'mensagem': erros[key]
              })
            });
            this.showPendenteModalImport = false
            this.errosValid = listaErros
            this.updating = false
          })
        }
      }
    },

    downloadErrorLog(errors) {
      if (!errors || errors.length === 0) {
        console.error("Nenhum erro encontrado para salvar.");
        return;
      }

      // Converte o array de erros em um texto formatado
      const errorText = errors.map(err => `Linha ${err.linha}: ${err.erro}`).join("\n");

      // Cria um Blob com o conteúdo do erro
      const blob = new Blob([errorText], { type: "text/plain" });

      // Cria uma URL temporária para o Blob
      const url = URL.createObjectURL(blob);

      // Cria um link para download
      const a = document.createElement("a");
      a.href = url;
      a.download = "erros.txt"; // Nome do arquivo
      document.body.appendChild(a);
      a.click(); // Aciona o clique para baixar
      document.body.removeChild(a); // Remove o link após o download

      // Revoga a URL com um pequeno delay
      setTimeout(() => {
        URL.revokeObjectURL(url);
      }, 1000);
    },


    exportExcel(){
      console.log('exportExcel')
      const data = this.movajtList
      const fileName = "exp_dados";
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({ data, fileName, exportType });
    },

    atualizaDataList(){
      this.loadingList = true
      api.get(`${getBaseUrl()}api/movajts`, {
        params: {
          'q': this.pesqTextFilter,
          's': this.statusFilter
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data[0])
        this.movajtList = res.data[0]
        this.title = `(${this.movajtList.length}) Movimentos de Ajuste`
        this.loadingList = false
        this.loadingGraph = false
      });
    },

    criarNovo() {
      console.log('criarNovo')
      // this.updating = !this.updating
    }
  },

}
</script>

<template>
  <Layout>

    <span class="float-end" style="z-index: 1000; position: absolute; top: 00px; right: 230px;">
      <Vue3Lottie :animationData="animationJson" :height="300" :width="300" />
    </span>

    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">


              <div class="col-sm-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input
                        id="inputPesquisa"
                        type="text"
                        v-model="pesqTextFilter"
                        class="form-control"
                        placeholder="Enter para pesquisar..."
                        @change="atualizaDataList"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-1">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <select
                        id="selectStatus"
                        v-model="statusFilter"
                        @change="atualizaDataList"
                        class="form-control select2-search-disable">
                      <option value="T" selected>Todos</option>
                      <option value="EL">Elaboração</option>
                      <option value="CO">Confirmados</option>
                      <option value="CA">Cancelados</option>
                    </select>
                    <i class="bx bx-filter-alt search-icon"></i>
                  </div>
                </div>
              </div>


              <div class="col-sm-2">
                <div class="mb-2 d-inline-block">
                  <div class="position-relative">
                    <b-button variant="outline-primary" class="" @click="exportExcel">
                      <i class="bx bx-export font-size-16 align-middle "></i>
                    </b-button>
                  </div>
                </div>
              </div>

              <div class="col-sm-7">
                  <div class="text-sm-end">
                    <button type="button" class="btn btn-success btn-rounded mb-2 me-2" @click="showModalImportarMovAjt = true">
                      <i class="mdi mdi-plus me-1"></i> Importar Ajustes
                    </button>
                  </div>

                  <div class="text-sm-end">
                    <router-link :to="`/movajuste/editar/0`">
                      <button type="button" class="btn btn-success btn-rounded mb-2 me-2" >
                        <i class="mdi mdi-plus me-1"></i> Novo Ajuste
                      </button>
                    </router-link>
                  </div>
              </div>
            </div>


            <Loader v-if="loadingList" style="min-height: 400px;">
            </Loader>

            <TransferenciasTable v-if="!loadingList"  :movajtList="movajtList"/>


            <ul class="pagination pagination-rounded justify-content-end mb-2">
              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Previous">
                  <i class="mdi mdi-chevron-left"></i>
                </a>
              </li>
              <li class="page-item active">
                <a class="page-link" href="javascript: void(0);">1</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript: void(0);">2</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript: void(0);">3</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript: void(0);">4</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript: void(0);">5</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript: void(0);" aria-label="Next">
                  <i class="mdi mdi-chevron-right"></i>
                </a>
              </li>
            </ul>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>

    <div class="row" v-if="!loadingGraph">

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Evolução Anual</h4>

            <apexchart
                class="apex-charts"
                height="350"
                type="line"
                dir="ltr"
                :series="pedChart1.series"
                :options="pedChart1.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Fornecedores</h4>

            <apexchart
                class="apex-charts"
                height="320"
                type="pie"
                dir="ltr"
                :series="pedChart2.series"
                :options="pedChart2.chartOptions"
            ></apexchart>

          </div>
        </div>
      </div>
    </div>

    <b-modal title="Upload de Ajuste" v-model="showModalImportarMovAjt" hide-footer>
      <div class="row">
        <div class="card-body d-flex justify-content-center">
          <button class="btn btn-info" @click="baixarModeloImportacao">
            <i class="bx bx-download me-1 text-end"></i> Baixar modelo importação
          </button>
        </div>
      </div>

      <div class="row">
        <div class="card-body">
          <h4 class="card-title">Selecionar novo arquivo</h4>
          <DropZone @change="selectedFile" />
          <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>
          <div v-if="submittedAnexo && !dropzoneFile.name" >
            <span class="text-danger font-size-11">Favor selecionar o arquivo e tentar novamente.</span>
          </div>
        </div>
      </div>

      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalImportarMovAjt = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarImportacaoMovAjt">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

    <b-modal
        v-model="showPendenteModalImport"
        size="md"
        title-class="font-12"
        title="Só um momento!"
        hide-footer
    >
      <h4>Estamos Processando sua Planilha...</h4>
    </b-modal>

  </Layout>
</template>
